import createRoutine from '@/utils/createRoutine'

export const fundingAppRoutine = createRoutine('fundingApp')

export const fundingGetters = {
  FUNDING_APP_ID: 'FUNDING_APP_ID'
}
